import * as React from "react";

const SvgBasket = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path
      id="basket_svg__a"
      d="M22.243 2.182c.97 0 1.757.786 1.757 1.756v.155c0 .256-.058.515-.167.747l-3.806 8.089a2.183 2.183 0 01-1.975 1.253H7.482c-.033.056-.065.114-.108.164l-1.73 2.018h15.629c.301 0 .545.244.545.545V18a.545.545 0 01-.545.545H5.645a2.17 2.17 0 01-2.089-1.546c-.231-.737-.005-1.546.498-2.133l1.273-1.485-3.408-11.2H.545A.545.545 0 010 1.637V.546C0 .243.244 0 .545 0h2.182c.48 0 .904.314 1.044.773l.44 1.444c.05-.015.099-.035.153-.035h17.88zM6.545 24a2.182 2.182 0 110-4.364 2.182 2.182 0 010 4.364zm13.091 0a2.182 2.182 0 110-4.364 2.182 2.182 0 010 4.364z"
    />
  </svg>
);

export default SvgBasket;
